import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  eventbooking: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the pages
export const fetchEventBooking = createAsyncThunk(
  "fetcheventbooking/pages",
  async ({ enqueueSnackbar, limit, page = 0, category }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`bookings`, {
        params: {
          page: page + 1,
          limit,

          populate: {
            event: true,
          },
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateEventBooking = createAsyncThunk(
  "updateEventBooking/pages",
  async ({ enqueueSnackbar, status, id, data }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`booking/${id}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteEventBooking = createAsyncThunk(
  "deleteBooking/booking",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`booking/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const eventBookingSlice = createSlice({
  name: "eventbooking",
  initialState,
  reducers: {
    resetPage: (state) => {
      state.fetchLoading = false;
      state.isLoading = false;
      state.eventbooking.data = [];
    },
  },
  extraReducers: (builder) => {
    // TODO: create page
    builder.addCase(fetchEventBooking.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchEventBooking.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.eventbooking = action.payload;
    });

    builder.addCase(fetchEventBooking.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
    builder.addCase(updateEventBooking.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(updateEventBooking.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.eventbooking.data = Object.assign(
        state.eventbooking.data,
        action.payload.data
      );
      action.payload.enqueueSnackbar("Event booking is updated successfully.", {
        variant: "success",
      });
    });

    builder.addCase(updateEventBooking.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete banner
    builder.addCase(deleteEventBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteEventBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.eventbooking.data = state.eventbooking.data.filter(
        (eventbooking) => eventbooking.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Event Booking is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteEventBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default eventBookingSlice.reducer;

export const { resetPage } = eventBookingSlice.actions;
